import {
    UI_SPORT_OVERVIEW_ACTIVE_GROUP,
    UI_SPORT_OVERVIEW_ACTIVE_SPORT,
    UI_SPORT_OVERVIEW_ANOTHER_GROUPS,
    UI_SPORT_OVERVIEW_BACK_BTN,
    UI_SPORT_OVERVIEW_NAVIGATION_TYPE,
    UI_SPORT_OVERVIEW_PARAMS,
    UI_SPORT_OVERVIEW_RESET,
    UI_SPORT_OVERVIEW_REST_EUROPE,
    UI_SPORT_OVERVIEW_REST_WORLD,
    UI_SPORT_OVERVIEW_SEARCH_TEXT,
    UI_SPORT_OVERVIEW_SHOW_ACTUAL_EVENTS,
    UI_SPORT_OVERVIEW_TOURANMENT_ID,
    UI_SPORT_OVERVIEW_TOURANMENT_STATUS,
} from 'constants/ui';

export function setOverviewNavType(type) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_NAVIGATION_TYPE,
            payload: type,
        });
    };
}

export function setOverviewActiveSport(sport) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_ACTIVE_SPORT,
            payload: sport,
        });
    };
}

export function setOverviewBackBtn(status) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_BACK_BTN,
            payload: status,
        });
    };
}

export function setOverviewActiveGroup(group) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_ACTIVE_GROUP,
            payload: group,
        });
    };
}

export function setOverviewIsShowActualEvents(status) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_SHOW_ACTUAL_EVENTS,
            payload: status,
        });
    };
}

export function setOverviewTournamentStatus(status) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_TOURANMENT_STATUS,
            payload: status,
        });
    };
}

export function setOverviewParams(params) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_PARAMS,
            payload: params,
        });
    };
}

export function setRestEurope(items) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_REST_EUROPE,
            payload: items,
        });
    };
}

export function setRestWorld(items) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_REST_WORLD,
            payload: items,
        });
    };
}

export function setAnotherGroups(items) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_ANOTHER_GROUPS,
            payload: items,
        });
    };
}

export function search(text) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_SEARCH_TEXT,
            payload: text,
        });
    };
}

export function setTournamentId(id) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_TOURANMENT_ID,
            payload: id,
        });
    };
}

export function reset() {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_OVERVIEW_RESET,
            payload: true,
        });
    };
}
